// extracted by mini-css-extract-plugin
export default {"contenButtons":"BtnAndTable_contenButtons__0NzNZ","disabled":"BtnAndTable_disabled__HHRBV"};